<ng-container *ngIf="(businessData$ | async)?.businessId; else deletedState">
  <ng-container *ngIf="pipelineBoardSlideoutStyling; then infoCardSlideout; else infoCardDefault"></ng-container>
</ng-container>

<ng-template #infoCardSlideout>
  <ng-container [ngTemplateOutlet]="contactInfoSlideout"></ng-container>
  <ng-container [ngTemplateOutlet]="businessCategoriesLayoutFirst"></ng-container>
</ng-template>

<ng-template #infoCardDefault>
  <mat-card appearance="outlined">
    <mat-card-header class="mat-card-header-with-action">
      <mat-card-title>
        <span>{{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.TITLE' | translate }}</span>
        <ng-content select="[afterTitle]"></ng-content>
      </mat-card-title>
      @if (businessEditUrl$ | async; as businessEditUrl) {
        <a mat-icon-button color="primary" [routerLink]="businessEditUrl">
          <mat-icon>edit</mat-icon>
        </a>
      }
    </mat-card-header>
    <mat-card-content>
      <ng-container [ngTemplateOutlet]="contactInfoDefault"></ng-container>
      <ng-container [ngTemplateOutlet]="socialMediaLayoutFirst"></ng-container>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #contactInfoSlideout>
  <ng-container *ngIf="businessData$ | async as bizData">
    <div>
      @if (businessDetailsUrl$ | async; as businessDetailsUrl) {
        <a class="business-name" [routerLink]="businessDetailsUrl" [queryParams]="{ origin: 'pipeline-board' }">
          {{ bizData.name }}
        </a>
      } @else {
        <div class="business-name">{{ bizData.name }}</div>
      }
      <div>{{ bizData.streetAddress }}</div>
      <div>
        {{ bizData.city }}, {{ bizData.state }},
        {{ bizData.countryCode }}
      </div>
      <div>{{ bizData.zip }}</div>
      <ng-container [ngTemplateOutlet]="phoneAndWebsite"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #contactInfoDefault>
  <ng-container *ngIf="businessData$ | async as bizData">
    <div class="contact-info">
      <div>{{ bizData.streetAddress }}</div>
      <div>{{ bizData.city }}, {{ bizData.state }}, {{ bizData.countryCode }} &nbsp;{{ bizData.zip }}</div>
      <ng-container [ngTemplateOutlet]="phoneAndWebsite"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #businessCategoriesLayoutFirst>
  <ng-container [ngTemplateOutlet]="businessCategories"></ng-container>
  <br />
  <sales-ui-localtime-card
    [accountGroupId]="(businessData$ | async)?.businessId"
    [editTimezoneUrl]="businessEditUrl$ | async"
  ></sales-ui-localtime-card>
  <ng-container [ngTemplateOutlet]="socialMedia"></ng-container>
</ng-template>

<ng-template #socialMediaLayoutFirst>
  <ng-container [ngTemplateOutlet]="socialMedia"></ng-container>
  <ng-container [ngTemplateOutlet]="businessCategories"></ng-container>
</ng-template>

<ng-template #phoneAndWebsite>
  <ng-container *ngIf="businessData$ | async as bizData">
    <div>
      <a [attr.href]="'tel:' + bizData.phoneNumber" data-action="clicked-business-tel" data-action-group="clicked-tel">
        {{ bizData.phoneNumber }}
      </a>
    </div>
    <div>
      <a [attr.href]="bizData.website" target="_blank">
        {{ bizData.website }}
      </a>
    </div>
  </ng-container>
</ng-template>

<ng-template #businessCategories>
  <div class="more-details">
    <div>
      <h3 class="card-title">
        {{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.BUSINESS_CATEGORY_LABEL' | translate }}
      </h3>
      <div class="name-and-icon">
        <category-overview
          class="async-text__subheading"
          [categoryIds]="vCategoryIds$ | async"
          [placeholder]="'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate"
        ></category-overview>
      </div>
    </div>
    <ng-container *ngIf="businessData$ | async as bizData">
      <div *ngIf="bizData?.serviceCategories?.length">
        <h3 class="card-title">
          {{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.SERVICE_CATEGORY_LABEL' | translate }}
        </h3>
        <ng-container
          *ngIf="bizData.serviceCategories.length === 1 && bizData.serviceCategories[0] === ''; else listCategories"
        >
          <div class="service-category-entry">
            {{ 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
          </div>
        </ng-container>
        <ng-template #listCategories>
          <div *ngFor="let sc of bizData.serviceCategories">
            <div class="service-category-entry">
              {{ sc }}
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>
    <div>
      <h3 class="card-title">{{ 'FRONTEND.SALES_UI.COMMON.MARKET_LABEL' | translate }}</h3>
      <sales-ui-async-text
        class="async-text__subheading"
        failTooltipText="{{
          'FRONTEND.SALES_UI.ERRORS.UNABLE_TO_LOAD_DISPLAY_VALUE' | translate: { value: 'market' }
        }}  {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CLICK_TO_RETRY' | translate }}"
        [loadFailed]="marketNameFailed$ | async"
        [loading]="marketNameLoading$ | async"
        (retry)="triggerGetMarketNameWork()"
      >
        {{ marketName$ | async }}
      </sales-ui-async-text>
    </div>
    <div>
      <h3 class="card-title">
        {{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.TAGS_LABEL' | translate }}
      </h3>
      @if (businessTags()?.length > 0) {
        <div class="tag-container">
          <span class="tag-list" *ngFor="let tag of businessTags()">
            <va-badge small color="gray">{{ tag.name }}</va-badge>
          </span>
        </div>
      } @else {
        <span class="async-text__subheading">
          {{ 'FRONTEND.SALES_UI.COMMON.NONE_LABEL' | translate }}
        </span>
      }
    </div>
  </div>
</ng-template>

<ng-template #socialMedia>
  <div class="social-media-container" *ngIf="socialUrls$ | async as socialUrls">
    <div [ngClass]="pipelineBoardSlideoutStyling ? 'social-media-row-for-board' : 'social-media-row'">
      <mat-icon
        *ngIf="!!socialUrls?.facebookUrl; else inactiveFacebook"
        svgIcon="Facebook"
        class="social-icon-active"
        (click)="openUrl(socialUrls?.facebookUrl)"
      ></mat-icon>
      <ng-template #inactiveFacebook>
        <mat-icon svgIcon="Facebook" class="social-icon-inactive"></mat-icon>
      </ng-template>
      <mat-icon
        *ngIf="!!socialUrls?.twitterUrl; else inactiveTwitter"
        svgIcon="Twitter"
        class="social-icon-active"
        (click)="openUrl(socialUrls?.twitterUrl)"
      ></mat-icon>
      <ng-template #inactiveTwitter>
        <mat-icon svgIcon="Twitter" class="social-icon-inactive"></mat-icon>
      </ng-template>
      <mat-icon
        *ngIf="!!socialUrls?.linkedinUrl; else inactiveLinkedin"
        svgIcon="LinkedIn"
        class="social-icon-active"
        (click)="openUrl(socialUrls?.linkedinUrl)"
      ></mat-icon>
      <ng-template #inactiveLinkedin>
        <mat-icon svgIcon="LinkedIn" class="social-icon-inactive"></mat-icon>
      </ng-template>
      <mat-icon svgIcon="business-search" class="social-icon-active" (click)="googleSearchForBusiness()"></mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #deletedState>
  <glxy-badge [color]="'red'">{{ 'FRONTEND.SALES_UI.COMMON.DELETED' | translate }}</glxy-badge>
</ng-template>
